import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { requiredWhenPresent } from '../../shared/propTypes';

import {
  hideDeleteModal,
  deleteBusinessUnit,
} from './store/actions';
import Modal from '../../shared/modals/modal.component';

class DeleteBusinessUnitModal extends PureComponent {
  static propTypes = {
    hideDeleteModal: PropTypes.func.isRequired,
    deleteBusinessUnit: PropTypes.func.isRequired,
    entityToRemove: requiredWhenPresent(['isVisible'], PropTypes.shape({
      periodName: PropTypes.string.isRequired,
      businessUnit: PropTypes.string.isRequired,
      businessUnitDescription: PropTypes.string.isRequired,
    })),
    isVisible: PropTypes.bool,
    rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),

  };

  removeBusinessUnit = () => {
    const { deleteBusinessUnit, entityToRemove, rowIndex } = this.props;
    deleteBusinessUnit(entityToRemove, { rowIndex });
  };

  render() {
    const {
      hideDeleteModal,
      entityToRemove,
      isVisible,
    } = this.props;

    return (
      <Modal
        className="add-business-unit-modal"
        title="Delete Business Unit"
        closeAction={hideDeleteModal}
        dismissText="Cancel"
        dismissAction={hideDeleteModal}
        submitText="Yes"
        submitAction={this.removeBusinessUnit}
        isVisible={isVisible}
      >
        { entityToRemove
          ? (
            <div>
              Are you sure you want to delete: <br/><br/>
              Business Unit: {entityToRemove.businessUnit}<br/>
              Description: {entityToRemove.businessUnitDescription}<br/>
              Period: {entityToRemove.periodName}<br/><br/>
            </div>
          )
          : null
        }
      </Modal>
    );
  }
}

export default connect(
  null,
  {
    hideDeleteModal,
    deleteBusinessUnit,
  }
)(DeleteBusinessUnitModal);
